// Tracks fbOrderLineIds this POS terminal itself just fired to the kitchen, so the
// ORDER_UPSERT WS merge (useWebSocketHandler.js) can tell "a lagging echo of a state
// this terminal already moved past" apart from "a genuine update from elsewhere (e.g.
// the Mobile App)" — see BUG-1921. Module-level (not React state): the two call sites
// (useOrderHandlers.js fire handler, useWebSocketHandler.js merge) don't share a
// component tree, and this only needs to survive a short in-memory window.
const recentLocalFires = new Map();
const WINDOW_MS = 20000;
const MAX_ENTRIES = 200;

export const markLocalFire = (fbOrderLineId) => {
  if (!fbOrderLineId) return;
  recentLocalFires.set(fbOrderLineId, Date.now());
  if (recentLocalFires.size > MAX_ENTRIES) {
    recentLocalFires.delete(recentLocalFires.keys().next().value);
  }
};

export const wasRecentlyFiredLocally = (fbOrderLineId) => {
  if (!fbOrderLineId) return false;
  const firedAt = recentLocalFires.get(fbOrderLineId);
  return typeof firedAt === "number" && Date.now() - firedAt < WINDOW_MS;
};
